import { useState } from "react";
import "./classview.css";
import { useNavigate } from "react-router-dom";
import Staff from "../../../components/Staff";
import Time from "../../../components/Time";
import mut from "../../../hooks/mut";
import EditClass from "./EditClass";
import DialogHT from "../../../components/DialogHT";
import ContextMenu from "./ContextMenu";
import NewForeignTeacherDialog from "./NewForeignTeacherDialog";
import RemoveFTDialog from "./RemoveFTDialog";
import EditTeacherDialog from "./EditTeacherDialog";
import RetireDialog from "./RetireDialog";
import EditNameDialog from "./EditNameDialog";
import EditSyllabusDialog from "./EditSyllabusDialog";
import useCTX from "../../../hooks/useCTX";
import EditDays from "./EditDays";
/* import NewBookDialog from "./NewBookDialog"; */



export default function ClassView(props) {
  const { htClass, teacherFilter, search, setClasses, day, week, update,replace } = props;
  const { user } = useCTX()
  const navigate = useNavigate();
  const [openEditClass, setOpenEditClass] = useState(false);
  const [openAddTest, setOpenAddTest] = useState(false);
 /*  const [openMoveNextBook, setOpenMoveNextBook] = useState(false); */
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, });
  const [addForeignTeacher, setAddForeignTeacher] = useState(false)
  const [removeForeignTeacher, setRemoveForeignTeacher] = useState(false);
  const [openEditTest, setOpenEditTest] = useState(false);
  const [openChangeTeacher, setOpenChangeTeacher] = useState(false);
  const [openRetire, setOpenRetire] = useState(false)
  const [openName, setOpenName] = useState(false)
  const [openUpdateSyllabus, setOpenUpdateSyllabus] = useState(false);
  const [openEditDays, setOpenEditDays] = useState(false);


  const [searchHit,filter] = checkSearch(search, teacherFilter, htClass)

  const frameHeight = 74;

  // context menu

  const handleContextMenu = (event) => {
     if (user.roles.includesOne(["Manager","Head Teacher"])) {
       event.preventDefault();
       const menuWidth = 200; // adjust to match Tailwind max-w
       const menuHeight = 300; // adjust to match Tailwind max-h
       const padding = 10;

       let left = event.clientX;
       let top = event.clientY;

       if (left + menuWidth > window.innerWidth) {
         left = window.innerWidth - menuWidth - padding;
       }

       if (top + menuHeight > window.innerHeight) {
         top = window.innerHeight - menuHeight - padding;
       }



       setContextMenu({ visible: true, x: left, y: top });
     }
  };


  const handleCustomContextAction = async (action) => {
  
    setContextMenu({ visible: false, x: 0, y: 0 });
     if (action === "editClass") {
       setOpenEditClass(true);
    }

     if (action === "addForeignTeacher") {
       setAddForeignTeacher(true);
    }

     if (action === "changeTeacher") {
       setOpenChangeTeacher(true);
     }
    
    /* if (action === "editForeignTeacher") {
      setOpenEditForeignTeacher(true);
    } */

    if (action === "removeForeignTeacher") {
        setRemoveForeignTeacher(true)
    }

     if (action === "addTest") {
       setOpenAddTest(true);
    }
     if (action === "editTest") {
       setOpenEditTest(true);
     }
    if (action === "removeTest") {
     let result = await mut(
       "post",
       `/class-timetable-remove-test/${htClass._id}`,{test: htClass.test._id}
      );
    
     replace(result);

    }
   /*  if (action === "moveNextBook") {
      setOpenMoveNextBook(true)
    } */
      if (action === "retireClass") {
        setOpenRetire(true);
    }
    if (action === "editName") {
      setOpenName(true);
    }
    if (action === "updateTheSyllabus") {
      setOpenUpdateSyllabus(true);
    }

     if (action === "editDays") {
       setOpenEditDays(true);
     }
  };

  const handleClickAway = () => {
    setContextMenu({ visible: false, x: 0, y: 0 });
  };

  const addTest = async (test) => { 
    let result = await mut("post", `/add-test/${htClass._id}`, test)
    update(result)
    setOpenAddTest(false);
  }


  let lessonOrTest = htClass.lessonOrTest ? `/${htClass.lessonOrTest.type}` : "/undefined/no-syllabus"
  if (htClass.lessonOrTest) {
    if (htClass.lessonOrTest.type === "lesson")
      lessonOrTest += `/${htClass.lessonOrTest.lesson.unit._id}/${htClass.lessonOrTest.lesson._id}`;
    if (htClass.lessonOrTest.type === "test")
      lessonOrTest += `/${htClass.lessonOrTest.unit._id}`;
    if (htClass.lessonOrTest.type === "undefined")
      lessonOrTest += `/no-syllabus`;
  }
  


  return (
    <div onContextMenu={handleContextMenu}>
      <div
        className={
          !searchHit && filter !== ""
            ? "frameDisabled"
            : htClass.status === "Coming"
            ? "class-coming"
            : (htClass.level && htClass.level.toLowerCase()) || "frame"
        }
        onClick={() => navigate(`/class/${htClass.htClass}` + lessonOrTest)}
        style={{ height: frameHeight, cursor: "pointer" }}
      >
        <div>
          <div className={"classtitle"}>{htClass.name}</div>
          <div className={"syllabus-title"}>{htClass.syllabusName || ""}</div>
        </div>
        <div
          className={"teachersName"}
          variant="subtitle2"
        >
          <Staff id={htClass.teacher} />
        </div>
        <div
          className={"classRoom"}
          variant="subtitle2"
          sx={{ color: "#5df4fc", fontSize: 12, fontWeight: "normal" }}
        >
          {htClass.room}
        </div>
        <TestOrUnit htClass={htClass} />

        <NumberOfStudents
          numberOfStudents={htClass.students.length}
          htClass={htClass}
        />

        <OtherTeachers htClass={htClass} />
      </div>
      {contextMenu.visible && (
        <ContextMenu
          handleClickAway={handleClickAway}
          handleCustomContextAction={handleCustomContextAction}
          contextMenu={contextMenu}
          htClass={htClass}
          /*   test={test} */
        />
      )}
      <EditClass
        open={openEditClass}
        setOpen={setOpenEditClass}
        htClass={htClass}
        setClasses={setClasses}
        week={week}
        day={day}
      />
      <NewForeignTeacherDialog
        open={addForeignTeacher}
        setOpen={setAddForeignTeacher}
        htClass={htClass}
        setClasses={setClasses}
        week={week}
        day={day}
      />
      <RemoveFTDialog
        open={removeForeignTeacher}
        setOpen={setRemoveForeignTeacher}
        htClass={htClass}
        setClasses={setClasses}
        week={week}
        day={day}
      />
      {/* <NewBookDialog
        open={openMoveNextBook}
        setOpen={setOpenMoveNextBook}
        htClass={htClass}
        setClasses={setClasses}
        week={week}
      /> */}

      <DialogHT
        open={openAddTest}
        setOpen={setOpenAddTest}
        title="addATest"
        content={[
          { name: "room", label: "room", multiline: true, rows: 3 },
          {
            name: "unit",
            label: "unit",
            type: "number",
            state: htClass.currentUnit,
          },
          { name: "testLink", label: "linkToTestSheet", notRequired: true },
          {
            name: "powerpointLink",
            label: "linkToPowerpointPresentation",
            notRequired: true,
          },
        ]}
        success={addTest}
      />
      <RetireDialog
        open={openRetire}
        setOpen={setOpenRetire}
        lesson={htClass}
        setLessons={setClasses}
      />
      <EditTeacherDialog
        open={openChangeTeacher}
        setOpen={setOpenChangeTeacher}
        lesson={htClass}
        update={update}
      />
      {htClass.test && (
        <DialogHT
          open={openEditTest}
          setOpen={setOpenEditTest}
          title="addATest"
          content={[
            {
              name: "room",
              label: "room",
              multiline: true,
              rows: 3,
              state: htClass.test.room,
            },
            {
              name: "unit",
              label: "unit",
              type: "number",
              state: htClass.test.unit,
            },
            {
              name: "testLink",
              label: "linkToTestSheet",
              notRequired: true,
              state: htClass.test.testLink,
            },
            {
              name: "powerpointLink",
              label: "linkToPowerpointPresentation",
              notRequired: true,
              state: htClass.test.powerpointLink,
            },
            {
              name: "grammarTestLink",
              label: "linkToGrammarTest",
              notRequired: true,
              state: htClass.test.grammarTestLink,
            },
          ]}
          url={`/test/${htClass.test._id}`}
          success={(test) => {
            htClass.test = test;
            setClasses((prev) =>
              prev.map((p) => (p._id === htClass._id ? htClass : p))
            );
          }}
        />
      )}
      <EditDays
        open={openEditDays}
        setOpen={setOpenEditDays}
        lesson={htClass}
        update={update}
        day={day}
        week={week}
      />
      <EditNameDialog
        open={openName}
        setOpen={setOpenName}
        lesson={htClass}
        setClasses={setClasses}
        week={week}
      />
      <EditSyllabusDialog
        open={openUpdateSyllabus}
        setOpen={setOpenUpdateSyllabus}
        lesson={htClass}
        update={update}
        week={week}
      />
    </div>
  );
}

function TestOrUnit({ htClass }) {
  
  if (!htClass.lessonOrTest) return <div></div>
  const lt = htClass.lessonOrTest
  if(lt.type==="undefined") return <div className="classRoom">No syllabus</div>;
  if(lt.type==="lesson" && lt.lesson)  return (
      <div className="classRoom text-shadow-green-500">    
        U{htClass.lessonOrTest.lesson.unit.unitNumber} / L{htClass.lessonOrTest.lesson.lessonNumber}
      </div>
    );
  if (lt.type === "test") return <div className="classRoom text-amber-300">Test</div>
  return <div></div>

/*   if (!htClass.test.powerpointLink && !htClass.test.testLink) return (
    <div className={"classRoom"}>
      <div className="class-view-test">Test U{htClass.test.unit}</div>
      <div style={{ color: "#ff5e8c" }}>Nothing ready</div>
    </div>
  );

  if (htClass.test.powerpointLink && !htClass.test.testLink) return (
    <div className={"classRoom"}>
      <div className="class-view-test">Test U{htClass.test.unit}</div>
      <div style={{ color: "#f79900" }}>Test not ready</div>
    </div>
  );

  if (!htClass.test.powerpointLink && htClass.test.testLink)
    return (
      <div className={"classRoom"}>
        <div className="class-view-test">Test U{htClass.test.unit}</div>
        <div style={{ color: "#f79900" }}>PPT not ready</div>
      </div>
    );
    return (
      <div className={"classRoom"}>
        <div className="class-view-test">Test U{htClass.test.unit}</div>
        <div className="class-view-test">Ready</div>
      </div>
    ); */
}

function OtherTeachers({htClass}) {
  if (!htClass.foreignTeacher) return <></>
  return (
    <div className="other-teacher">
      <div key={htClass._id}>
        <div style={{display:"flex", alignItems:"center"}}>
          <div>
            <Staff id={htClass.foreignTeacher} />{" "}
            <Time
              time={htClass.FTStartTime}
              short
            />{" "}
            -{" "}
            <Time
              time={htClass.FTEndTime}
              short
            />
          </div>
         
        </div>
      </div>
    </div>
  );
}


function NumberOfStudents({numberOfStudents,htClass}) {
          let color = "#7aff7d";
          if (
            Math.abs(htClass.targetStudents - numberOfStudents) > 1 &&
            Math.abs(htClass.targetStudents - numberOfStudents) < 4
          ) {
            color = "#fffbad";
          }
          if (Math.abs(htClass.targetStudents - numberOfStudents) >= 4) {
            color = "#ffadad";
          }
  return (
    <div
      style={{ color }}
      className={"activeStudents"}
    >
      {numberOfStudents}/{htClass.targetStudents}
    </div>
  );
}

function checkSearch(search,teacherFilter,htClass) {
   let searchHit = false;
   let filter = search;
   if (teacherFilter !== "") filter = teacherFilter;

   if (search !== "") {
     if (htClass.name.toUpperCase().includes(search.toUpperCase()))
       searchHit = true;
   }
   if (teacherFilter !== "") {
     if (
       htClass.teacher === teacherFilter ||
       htClass.foreignTeacher === teacherFilter
     )
       searchHit = true;
  }
  return [searchHit,filter]
}